import { REPORT_ACTION_TYPE, ReportActions } from './report-type';
import { RootState } from '../../../../redux/root-reducer';

export enum REPORT_STATE_KEY {
  SHOP_LIST = 'shop_list',
  REPORT_LIST = 'report_list',
  EMAIL_LIST_SHOPS = 'email_list_shop',
  EMAIL_LIST_VAT = 'email_list_vat',
  ALERT_SUCCESS = 'alert_success',
  VERIFY_STATUS = 'verify_status',
  ALERT_STATE = 'alert_state',
  ALERT_COUNTDOWN = 'alert_count',
  REPORT_TYPE_SELECTED = 'report_type_selected',
  REPORT_RESPONSE = 'report_response',
}

export enum REPORT_ALERT {
  ALERT_BLANK = 'alert_blank',
  ALERT_REPORT_TYPE_SUCCESS = 'alert_report_type_success',
  ALERT_REPORT_TYPE_FAIL = 'alert_report_type_fail',
}

export type ReportState = {
  [REPORT_STATE_KEY.SHOP_LIST]?: { shopName: string, shopId: number }[],
  [REPORT_STATE_KEY.REPORT_LIST]?: [],
  [REPORT_STATE_KEY.EMAIL_LIST_SHOPS]?: [],
  [REPORT_STATE_KEY.EMAIL_LIST_VAT]?: [],
  [REPORT_STATE_KEY.ALERT_SUCCESS]?: boolean,
  [REPORT_STATE_KEY.VERIFY_STATUS]?: string,
  [REPORT_STATE_KEY.ALERT_STATE]: REPORT_ALERT,
  [REPORT_STATE_KEY.ALERT_COUNTDOWN]: boolean,
  [REPORT_STATE_KEY.REPORT_TYPE_SELECTED]?: number
  [REPORT_STATE_KEY.REPORT_RESPONSE]?: any
};

const initialState: ReportState = {
  [REPORT_STATE_KEY.EMAIL_LIST_SHOPS]: [],
  [REPORT_STATE_KEY.EMAIL_LIST_VAT]: [],
  [REPORT_STATE_KEY.ALERT_SUCCESS]: false,
  [REPORT_STATE_KEY.ALERT_STATE]: REPORT_ALERT.ALERT_BLANK,
  [REPORT_STATE_KEY.ALERT_COUNTDOWN]: false
};

export const reportReducers = (state = initialState, action: ReportActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case REPORT_ACTION_TYPE.SET_REPORT_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const reportStateSelector = (key: REPORT_STATE_KEY) => (state: RootState) => state.report[key];
